import { useDict } from '../../i18n/dictionary';
import { api } from '../../lib/api';
import {
  useCreateResource,
  useDeleteResource,
  useResourceQuery,
  useUpdateResource,
} from '../../lib/crud';
import { financesDict } from './i18n';

// Coarse on purpose: a wallet edit moves the overview's waterfall too, so every
// finances mutation invalidates the whole namespace.
const FINANCES = ['finances'] as const;

export function useWallets() {
  const t = useDict(financesDict);
  return useResourceQuery(
    [...FINANCES, 'wallets'],
    api.finances.listWallets,
    t.loadWalletsFailed,
  );
}

export function useGoals() {
  const t = useDict(financesDict);
  return useResourceQuery(
    [...FINANCES, 'goals'],
    api.finances.listGoals,
    t.loadGoalsFailed,
  );
}

export function useOverview() {
  const t = useDict(financesDict);
  return useResourceQuery(
    [...FINANCES, 'overview'],
    api.finances.overview,
    t.loadOverviewFailed,
  );
}

export function useCreateWallet() {
  const t = useDict(financesDict);
  return useCreateResource(
    FINANCES,
    api.finances.createWallet,
    t.createWalletFailed,
  );
}

export function useUpdateWallet() {
  const t = useDict(financesDict);
  return useUpdateResource(
    FINANCES,
    api.finances.updateWallet,
    t.saveWalletFailed,
    t.walletSaved,
  );
}

export function useDeleteWallet() {
  const t = useDict(financesDict);
  return useDeleteResource(
    FINANCES,
    api.finances.deleteWallet,
    t.deleteWalletFailed,
  );
}

export function useCreateGoal() {
  const t = useDict(financesDict);
  return useCreateResource(
    FINANCES,
    api.finances.createGoal,
    t.createGoalFailed,
  );
}

export function useUpdateGoal() {
  const t = useDict(financesDict);
  return useUpdateResource(
    FINANCES,
    api.finances.updateGoal,
    t.saveGoalFailed,
    t.goalSaved,
  );
}

export function useDeleteGoal() {
  const t = useDict(financesDict);
  return useDeleteResource(
    FINANCES,
    api.finances.deleteGoal,
    t.deleteGoalFailed,
  );
}
